<script setup>
const props = defineProps({
  error: {
    type: Object,
    required: true
  }
})

const errorConfig = computed(() => {
  const configs = {
    404: {
      title: '404 - یافت نشد',
      message: 'صفحه‌ای که به دنبال آن بودید ممکن است حذف شده باشد یا آدرس را نادرست وارد کرده باشید.',
      icon: 'bold:clipboard-close',
      iconColor: 'text-yellow-90',
      bgColor: 'bg-yellow-90/10',
      showHomeButton: true
    },
    401: {
      title: '401 - غیر مجاز',
      message: 'شما برای دسترسی به این صفحه مجاز نیستید. لطفا وارد حساب کاربری خود شوید.',
      icon: 'bold:close-circle',
      iconColor: 'text-yellow-90',
      bgColor: 'bg-yellow-90/10',
      showHomeButton: false
    },
    500: {
      title: 'خطای سرور',
      message: 'سرور وبسایت به طور موقت از دسترس خارج شده است لطفا پس از چند دقیقه دوباره امتحان کنید',
      icon: 'bold:close-circle',
      iconColor: 'text-red-90',
      bgColor: 'bg-red-90/10',
      showHomeButton: false
    },
    503: {
      title: 'خطای اتصال',
      message: 'مشکل در ارتباط با سرور - لطفاً اتصال اینترنت خود را بررسی کنید و دوباره تلاش نمایید.',
      icon: 'bold:wifi-square',
      iconColor: 'text-yellow-90',
      bgColor: 'bg-yellow-90/10',
      showHomeButton: false
    }
  }

  const statusCode = props.error?.statusCode;

  return statusCode === 404 ? configs[404] : statusCode === 401 ? configs[401] : statusCode === 500 ? configs[500] : configs[503];
})

useHead({
  title: errorConfig.value.title
})
</script>

<template>
  <div class="container flex items-center justify-center h-screen">
    <div class="bg-white w-full max-w-120 mx-auto px-5 py-7 sm:p-10 rounded-lg">
      <div class="text-center">
        <div
            :class="errorConfig.bgColor"
            class="flex items-center justify-center size-14 md:size-16 mx-auto mb-3 md:mb-4 rounded-full"
        >
          <Icon
              :name="errorConfig.icon"
              :class="errorConfig.iconColor"
              class="size-8 md:size-10"
          />
        </div>

        <h2 class="text-t4 md:text-t3 font-bold mb-2">
          {{ errorConfig.title }}
        </h2>

        <p class="text-label md:text-caption text-secondary max-w-120 mx-auto">
          {{ errorConfig.message }}
        </p>
      </div>

      <div
          v-if="errorConfig.showHomeButton"
          class="w-60 mx-auto mt-5 md:mt-6"
      >
        <NuxtLink
            to="/"
            class="flex items-center justify-center text-white bg-primary text-caption font-medium py-2.5 rounded-lg hover:bg-primary-dark transition-colors"
        >
          بازگشت به خانه
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style>
@reference "~/assets/styles/app.css";

body{
  @apply bg-black-10;
}
</style>